<template>
  <section>
    <div class="sendBtn" @click="getCode()">{{msg}}</div>
  </section>
</template>

<script>
export default {
  props: ['userPhone', 'randType'],
  data () {
    return {
      time: 0,
      msg: '获取验证码'
    }
  },
  methods: {
    // 发送倒计时
    'startTime': function () {
      let that = this
      that.time = 60
      window.time = setInterval(function () {
        that.msg = that.time + 'S'
        that.time--
        if (that.time <= 0) that.closeTime()
      }, 1000)
    },
    // 倒计时结束关闭
    'closeTime': function () {
      clearInterval(window.time)
      this.msg = '重新发送'
    },
    // 获取随机数
    'getRandomCode': function () {
      let that = this
      return new Promise(function (resolve, reject) {
        that.axios.post('../api/wx/sms', {
          userPhone: that.userPhone
        }, {
          emulateJSON: true
        }).then(function (response) {
          if (response.data.status === 0) {
            resolve(response.data.value)
          } else {
            reject(response.data.msg)
          }
        }).catch(function (response) {
          console.log(response)
          that.$store.commit('setToastMsg', '网络错误')
        })
      })
    },
    // 获取验证码
    'getCode': function () {
      if (this.userPhone === '') {
        this.$store.commit('setToastMsg', '手机号不能为空')
        return
      }
      if (this.time > 0) return
      let that = this
      that.msg = '发送中...'
      that.getRandomCode().then(function (res) {
        that.axios.post('../api/wx/getRand', {
          userPhone: that.userPhone,
          randType: that.randType,
          randomCode: res[0] + res[4] + res[8] + res[12]
        }, {
          emulateJSON: true
        }).then(function (response) {
          if (response.data.status === 0) {
            that.startTime()
          } else {
            that.$store.commit('setToastMsg', response.data.msg)
            that.msg = '重新发送'
          }
        }, function (response) {
          console.log(response)
          that.$store.commit('setToastMsg', '网络错误')
          that.msg = '重新发送'
        })
      }, function (err) {
        that.$store.commit('setToastMsg', err)
        that.msg = '重新发送'
      })
    }
  },
  created: function (s) {
  }
}
</script>

<style scoped>
.sendBtn{
  font-size: 15px;
  float: left;
  background-color: #06B570;
  margin-top: 4px;
  margin-left: 10px;
  color: white;
  height: 30px;
  line-height: 30px;
  width: 80px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/sendBtn.vue